import DOMPurify from "dompurify";

/**
 * Sanitize HTML rendered in contract previews (user/template placeholders may contain markup).
 */
export function sanitizeContractHtml(html) {
  if (html == null || html === "") {
    return "";
  }

  return DOMPurify.sanitize(String(html), {
    USE_PROFILES: { html: true },
  });
}
